import { getApprovedSupportUrl } from './SupportMediaPolicy';

export async function openSupportDocument(
  title: string,
  getSourceUrl: () => Promise<string>,
  notifyFailure: (message: string) => void,
  isCurrent: () => boolean
): Promise<void> {
  // Reserve the tab during the click, before awaiting the authenticated link.
  const tab = window.open('', '_blank');
  if (!tab) {
    notifyFailure('The document tab was blocked by your browser.');
    return;
  }
  tab.opener = null;
  tab.document.title = title;
  tab.document.body.textContent = 'Loading document...';
  const referrer = tab.document.createElement('meta');
  referrer.name = 'referrer';
  referrer.content = 'no-referrer';
  tab.document.head.appendChild(referrer);
  try {
    const address = await getSourceUrl();
    if (tab.closed || !isCurrent()) {
      if (!tab.closed) tab.close();
      return;
    }
    const url = getApprovedSupportUrl(address);
    if (!url) throw new Error('Invalid support document address.');
    tab.location.replace(url);
  } catch (error) {
    if (!tab.closed) tab.close();
    const status = (error as { response?: { status?: number } })?.response
      ?.status;
    console.error('Failed to open support document. Status:', status ?? 'none');
    if (isCurrent()) {
      notifyFailure(
        status === 404
          ? 'This document is no longer available.'
          : 'The document could not be opened. Please try again.'
      );
    }
  }
}
